export default "__VITE_ASSET__D6eDp4LU__"